import React, { Component } from "react";
import Storage from "../../services/storage.service";
import AnimatedLoader from "./Animated";

export default class MainSpinner extends Component {
	state = {
		text: "",
	};

	componentDidMount() {
		Storage.get_obsrv("loading_text").subscribe((data) => {
			this.setState({
				text: data,
			});
		});
	}

	render() {
		if (this.state.text) {
			return (
				<div className="vmo-loader-main">
					<div className="vmo-loader medium">
						<div className="vmo-loader-inner-animated">
							<AnimatedLoader />
						</div>
						<div className="vmo-loader-text">{this.state.text}</div>
					</div>
				</div>
			);
		}
		return "";
	}
}
